import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

Bugsnag.start({
  apiKey: "fc2543c37d2f9ab50c8c2d6c9f33420e",
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.REACT_APP_RELEASE_STAGE,
});
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
const app = (
  <BrowserRouter>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </BrowserRouter>
);
const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(app, rootElement);
} else {
  ReactDOM.render(app, rootElement);
}

// SEO shells (location/route pages) ship crawlable content in #static-seo.
// Keep it visible until the real page renders (the Suspense fallback is an
// empty div), then remove it so users never see duplicate content.
const staticSeo = document.getElementById("static-seo");
if (staticSeo) {
  const appHasRendered = () => (rootElement.textContent || "").trim().length > 40;
  if (appHasRendered()) {
    staticSeo.remove();
  } else {
    const observer = new MutationObserver(() => {
      if (appHasRendered()) {
        staticSeo.remove();
        observer.disconnect();
      }
    });
    observer.observe(rootElement, { childList: true, subtree: true });
  }
}
serviceWorker.unregister();
